import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import * as types from '../../constants/actionTypes';
import { actions as webAssetsActions } from '../../actions/webAssetsActions';
import { DATE_FORMAT } from '../../constants/constants';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import Icon from '../Common/Icon';
import LoadingIndicator from '../Common/LoadingIndicator/LoadingIndicator';
import Notification from '../Common/Notification';
import Modal from '../Common/Modal/Modal';
import WebAssetsDrawer from './WebAssetsDrawer';
import Moment from 'moment';
import './WebAssets.scss';

export class WebAssets extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            isLoading: false,
            isWebAssetDrawerOpen: false,
            showConfirmDeleteModal: false,
            webAssets: [
                {
                    path: '',
                    lastModifiedDate: '',
                    fileName: ''
                }
            ],
            fileToDelete: '',
            totalCount: 0,
            fileNameToReplace: ''
        }
    }

    componentDidMount = () => {
        this.search();
    };

    search = async () => {
        try {

            this.setState({ isLoading: true });
            const response = await this.props.webAssetsActions.search();
            if (response.type === types.SEARCH_WEB_ASSETS_SUCCESS) {
                this.setState({ 
                    webAssets: response.payload.webAssets, 
                    totalCount: response.payload.totalCount 
                });
            } else if (response.type === types.SEARCH_WEB_ASSETS_FAILURE) {
                this.setState({ webAssets: [], totalCount: 0 });
                Notification("error", "Error", response.payload.message);
            }

        } catch (error) {
            Notification("error", "Error", error);
            this.setState({ webAssets: [], totalCount: 0 });
        } finally {
            this.setState({ isLoading: false });
        }
    }

    onDelete = async () => {
        try {
            this.setState({ isLoading: true, showConfirmDeleteModal: false });
            const response = await this.props.webAssetsActions.deleteWebAsset(this.state.fileToDelete);
            if (response.type === types.DELETE_WEB_ASSETS_SUCCESS) {
                this.setState({ fileToDelete: ''}, this.search);
            } else if (response.type === types.DELETE_WEB_ASSETS_FAILURE){
                Notification("error", "Error", response.payload.message);
            }
        } catch (error) {
            Notification("error", "Error", error);
        } finally {
            this.setState({ isLoading: false });
        }
    }

    onShowConfirmDeleteFileModal = (fileName) => {
        this.setState({ showConfirmDeleteModal: true, fileToDelete: fileName });
    }

    onCancelDelete = () => {
        this.setState({ showConfirmDeleteModal: false, fileToDelete: ''  });
    }

    onAddNew = () => {
        this.setState({ isWebAssetDrawerOpen: true });
    }

    onEditAsset = (fileName) => {
        this.setState({ isWebAssetDrawerOpen: true, fileNameToReplace: fileName });
    }

    onDrawerSave = () => {
        this.setState({ isWebAssetDrawerOpen: false, fileNameToReplace: '' }, () => {
            this.search()
        });
    }

    onDrawerCancel = () => {
        this.setState({ isWebAssetDrawerOpen: false, fileNameToReplace: '' });
    }

    imageTemplate = (rowData) => {
        return <img src={`${rowData.path}?${new Date().getTime()}`} alt="Image" style={{ maxWidth: '150px', margin: '10px' }} />;
    }

    pathTemplate = (rowData) => {
        return <a href={rowData.path} target="_blank" rel="noopener noreferrer">{rowData.path}</a>;
    }

    lastModifiedDateTemplate = (rowData) => {
        if (rowData.lastModifiedDate && rowData.lastModifiedDate.trim().length > 0) {
            return Moment.utc(rowData.lastModifiedDate).format(DATE_FORMAT);
        } else {
            return '';
        }
    }

    deleteTemplate = (rowData) => {
        return (
            <div className="text-center actions-col">
                <i className="fas fa-lg fa-trash-alt" onClick={() => this.onShowConfirmDeleteFileModal(rowData.fileName)} />
                <i className="far fa-lg fa-pen-to-square" onClick={() => this.onEditAsset(rowData.fileName)} />
            </div>
        )
    }
    
    render() {
        return (
            <>
                <div className="webassets-page">
                    <div className="table-header">
                        <span className="title">Web Assets</span>
                        <div className="add-new-button">
                            <button type="button" className="btn btn-primary" onClick={this.onAddNew} alt="close popup"><span className="me-2">Add New</span><Icon name="plus-circle" /></button>
                        </div>
                    </div>

                    <LoadingIndicator isLoading={this.state.isLoading} hideWhileLoading={true}>
                        <div className="list-results-table">
                            <DataTable
                                filterDisplay="row"
                                className="p-datatable-sm p-datatable-striped"
                                value={this.state.webAssets}>
                                <Column field="path" header="Image" body={this.imageTemplate} style={{ width: '200px', textAlign: 'center' }} />
                                <Column field="path" header="Link" body={this.pathTemplate} />
                                <Column field="lastModifiedDate" header="Last Modified Date" body={this.lastModifiedDateTemplate} style={{ width: '100px' }} />
                                <Column field="fileName" body={this.deleteTemplate} style={{ width: '80px' }} />
                            </DataTable>
                            <div className="results-count">Total records: {this.state.totalCount}</div>
                        </div>
                    </LoadingIndicator>

                </div>
                { this.state.isWebAssetDrawerOpen &&
                    <WebAssetsDrawer
                        onCancel={this.onDrawerCancel}
                        onSave={this.onDrawerSave}
                        fileNameToReplace={this.state.fileNameToReplace} />
                }
                { this.state.showConfirmDeleteModal &&
                    <Modal id="confirmDelete"
                        title="Confirm Deletion"
                        body={<span>Are you sure you want to delete this file from Azure?</span>}
                        primaryButtonText="Delete"
                        secondaryButtonText="Cancel"
                        onPrimaryClick={this.onDelete}
                        onSecondaryClick={this.onCancelDelete}
                        onCloseClick={this.onCancelDelete}
                    />
                }
            </>
        )
    }
}

WebAssets.propTypes = {
    webAssetsActions: PropTypes.object.isRequired,
};

function mapDispatchToProps(dispatch){
    return {
        webAssetsActions: bindActionCreators(webAssetsActions, dispatch)
    }
}

export default connect(null, mapDispatchToProps)(WebAssets);
